var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      pointerEvents: "none",
      display: "block",
      width: "100%",
      height: "100%"
    },
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#25D366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.775 19.351C37.05 16.547 33.42 15 29.558 15c-7.956 0-14.442 6.663-14.442 14.872 0 2.618.66 5.185 1.93 7.428L15 45l7.659-2.074a14.051 14.051 0 0 0 6.899 1.802C37.513 44.728 44 38.065 44 29.855c0-3.96-1.502-7.7-4.225-10.504ZM29.558 42.23a11.69 11.69 0 0 1-6.107-1.717l-.446-.272-4.539 1.224 1.205-4.556-.28-.476a12.605 12.605 0 0 1-1.833-6.578c0-6.815 5.398-12.356 12.016-12.356 3.202 0 6.223 1.291 8.484 3.62s3.516 5.44 3.516 8.736c-.017 6.833-5.398 12.375-12.016 12.375Zm6.585-9.264c-.363-.187-2.129-1.088-2.459-1.207-.33-.119-.578-.187-.809.187-.247.374-.924 1.207-1.139 1.462-.214.255-.412.272-.775.085-.363-.187-1.519-.578-2.905-1.836-1.073-.986-1.8-2.21-2.014-2.566-.215-.374-.016-.578.165-.765.165-.17.363-.442.545-.646.181-.221.247-.374.363-.612.116-.255.066-.459-.033-.646-.083-.187-.809-2.023-1.106-2.753-.297-.731-.594-.63-.809-.646-.214-.017-.445-.017-.693-.017-.247 0-.627.085-.957.459-.33.373-1.271 1.274-1.271 3.093 0 1.836 1.287 3.587 1.469 3.841.181.255 2.542 3.995 6.156 5.61.859.39 1.535.611 2.064.781.858.29 1.65.238 2.277.153.694-.102 2.13-.9 2.443-1.767.297-.867.297-1.615.215-1.768-.116-.153-.363-.255-.727-.442Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhatsapp);
export default __webpack_public_path__ + "static/media/shareWhatsapp.9dbacb81d6a13155e21ee1667ccfee33.svg";
export { ForwardRef as ReactComponent };